import { useState, useEffect } from 'react';
import { META, ROUTES } from './data';
// Savoria Header — handwritten-script brand mark, plum underline, no rectangle bar
export default function Header({ page, setPage }) {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const h = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', h, { passive: true });
    return () => window.removeEventListener('scroll', h);
  }, []);
  return (
    <header className={`sticky top-0 z-40 bg-[#F1ECDF] transition-all duration-700 ${scrolled ? 'py-2 border-b border-[#0A0A0A]/15' : 'py-5'}`}>
      <div className="max-w-[1500px] mx-auto px-8 lg:px-14 grid grid-cols-[1fr_auto_1fr] items-baseline gap-6">
        <div className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#4A5638] hidden lg:block">— {META.tag} · est. {META.est}</div>
        <button onClick={() => setPage('home')} className="text-center" data-testid="resto-logo">
          <p className="font-serif italic text-4xl lg:text-5xl text-[#6B2D4A]" style={{fontFamily:'"Caveat","Brush Script MT",cursive'}}>{META.brand}</p>
          <span className="block w-12 h-px bg-[#6B2D4A] mx-auto mt-1" />
        </button>
        <nav className="hidden lg:flex items-center gap-6 justify-self-end">
          {ROUTES.map(r => (
            <button key={r.id} onClick={() => setPage(r.id)} data-testid={`resto-nav-${r.id}`}
              className={`relative font-serif italic text-base transition-colors ${page === r.id ? 'text-[#6B2D4A]' : 'text-[#0A0A0A]/65 hover:text-[#0A0A0A]'}`}>
              {r.label}
              {page === r.id && <span className="absolute -bottom-1 left-0 right-0 h-0.5 bg-[#6B2D4A]" style={{transform:'rotate(-1deg)'}} />}
            </button>
          ))}
        </nav>
      </div>
    </header>
  );
}
